import type SVGType from 'types/svg.types';

const FilePercentIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.91797 20.7977L17.0887 23.1406C18.1505 23.4451 19.258 22.8311 19.5625 21.7693L21.8365 13.8389L18.9226 8.58211L12.9147 6.85938C11.8529 6.55492 10.7454 7.16885 10.4409 8.23063L7.54672 18.3239C7.24226 19.3857 7.85619 20.4932 8.91797 20.7977Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5272 14.0105L17.4418 12.839L18.6133 8.75366"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip0_9039_48882)">
      <path
        d="M16.8626 15.7625L11.915 18.505"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <ellipse
        cx="15.4745"
        cy="19.7337"
        rx="0.880007"
        ry="0.879996"
        transform="rotate(16 15.4745 19.7337)"
        fill="currentColor"
      />
      <ellipse
        cx="13.3045"
        cy="14.5338"
        rx="0.880007"
        ry="0.879996"
        transform="rotate(16 13.3045 14.5338)"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_9039_48882">
        <rect
          width="9.6"
          height="9.6"
          fill="white"
          transform="translate(11.0762 11.2737) rotate(16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FilePercentIcon;
